<ng-container *ngIf="!!formGroup" [formGroup]="formGroup">
    <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>{{placeholder}}</mat-label>
        <textarea matInput [formControlName]="fcName"></textarea>
    </mat-form-field>
</ng-container>